import React, { Component } from "react"
import * as projectActions from "../../actions/projectsActions"
import { connect } from "react-redux"
import { message } from "antd"
import ReactTable from "react-table"
import Loader from "../../../containers/Loader/Loader"
import Table from "../Role/Table"
import AuthContext from '../../../services/Auth'
class UploadProjects extends Component {
    constructor(props) {
        super(props);
        this.reactTable = React.createRef();
        this.state = {
            upload: [],
            loaderButton: false,
            error: "",
            loading: false
        }
    }

    // componentDidMount() {
    //     this.props.getActiveProjects();
    // }

    uploadFile = (file) => {
        let projectArray = {
            projects: []
        };
        this.setState({ upload: [] })
        var reader = new FileReader();
        reader.onloadend = (valueRead) => {

            var arrayBuffer = valueRead.currentTarget.result;
            if (arrayBuffer) {
                var projectAssignArray = arrayBuffer.split("\n");
                for (var index = 1; index < projectAssignArray.length; index++) {
                    var projectDetailsArray = projectAssignArray[index].split(",");
                    if (projectDetailsArray[0] != "") {
                        var ProjectJsonValue = {
                            projectCode: projectDetailsArray[0],
                            projectName: projectDetailsArray[1],
                            message: projectDetailsArray[2],
                            startTime: projectDetailsArray[3],
                            endDate: projectDetailsArray[4],
                            currentHours: projectDetailsArray[5],
                            expectedHours: projectDetailsArray[6],
                            color:  "#000000" + "a1",
                            status: "1",
                            image: "",
                            imageName: "",
                            imageSize: 0,
                            createdBy: AuthContext.getCachedUser() && AuthContext.getCachedUser().profile.unique_name
                        }
                        projectArray.projects.push(ProjectJsonValue);
                    }
                    if (projectAssignArray.length - 2 == this.state.upload.length) {
                        this.setState({ loaderButton: false, viewTable: true })

                    }
                }
                const uploadPromise = this.props.addProjects(projectArray)
                    .then(() => {
                        message.success("Project uploaded successfully");
                        this.setState({ loaderButton: false, error: "" });
                    })
                    .catch(() => {
                        message.error("Project upload failed. Please try again.");
                        this.setState({ loaderButton: false });
                    });
                this.setState({ upload: projectArray.projects })
                return uploadPromise;
            }



        }
        reader.readAsBinaryString(file)

    }
    onTableViewChange = () => {
        const current = this.reactTable.current;
        if (current) {
            const page = current.state.page;
            const pageSize = current.state.pageSize;
            const allData = current.getResolvedState().sortedData;
            const startIdx = page * pageSize;
            const currentData = allData.map((item) => item._original);
            this.setState({ studentsDowload: currentData })

        }
    }

    download = (items) => {
        var outputArray = [{ projectCode: "Project Code", projectName: "Project Name", projectDescription: "Project Description", 
            startDate: "Start Date" , endDate: "End Date" , currentHours: "Current Hours" , expectedHours: "Expected Hours"
        }];
        for (var index in items) {
            outputArray.push({
                projectCode: items[index].projectCode,
                projectName: items[index].projectName,
                projectDescription: items[index].message,
                startDate: items[index].startTime,
                endDate: items[index].endDate,
                currentHours: items[index].currentHours,
                expectedHours: items[index].expectedHours,
                status: (items[index].status ? "Success" : "Already Exists")
            })
        }
        // var jsonObject = JSON.stringify(outputArray);
        var csv = this.convertToCSV(outputArray);
        var exportedFilenmae = 'Projects CSV Upload Output.csv';
        var blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        if (navigator.msSaveBlob) { // IE 10+
            navigator.msSaveBlob(blob, exportedFilenmae);
        } else {
            var link = document.createElement("a");
            if (link.download !== undefined) { // feature detection
                // Browsers that support HTML5 download attribute
                var url = URL.createObjectURL(blob);
                link.setAttribute("href", url);
                link.setAttribute("download", exportedFilenmae);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
    }

    convertToCSV = (array) => {
        var str = '';
        for (var i = 0; i < array.length; i++) {
            var line = '';
            for (var index in array[i]) {
                if (line != '') line += ',';  // Add comma between values
                line += array[i][index];
            }
            str += line + '\n';  // Add newline after each row
        }
        return str;
    }

    static getDerivedStateFromProps = (nextProps, state) => {
        if (nextProps.upload.uploaded) {
            return {
                loaderButton: false,
                viewTable: true,
            }
        }

    }
    render() {
        const columns = [
            { Header: 'Project Code', filterable: true, accessor: 'projectCode' },
            { Header: 'Project Name', filterable: true, accessor: 'projectName' },
            { Header: 'Project Description', filterable: true, accessor: 'message' },
            { Header: 'Start Date', filterable: true, accessor: 'startTime' },
            { Header: 'End Date', filterable: true, accessor: 'endDate' },
            { Header: 'Current Hours', filterable: true, accessor: 'currentHours' },
            { Header: 'Expected Hours', filterable: true, accessor: 'expectedHours' },
            {
                Header: 'Status', filterable: true, accessor: 'status',
                Cell: props => {
                    return (
                        props.value ?
                            (props.value == 2 ? <div className="status" style={{ backgroundColor: "red", borderRadius: 5, color: "white", paddingLeft: 5, paddingRight: 5 }}>You haven't permission </div> :
                                (props.value == 4 ? <div className="status" style={{ backgroundColor: "red", borderRadius: 5, color: "white", paddingLeft: 5, paddingRight: 5 }}> email is incorrect</div> :
                                    (props.value == 1 ? <div className="status" style={{ backgroundColor: "green", borderRadius: 5, color: "white", paddingLeft: 5, paddingRight: 5 }}>Success</div> :
                                        null)))
                            :
                            <div className="status" style={{ backgroundColor: "red", borderRadius: 5, color: "white", paddingLeft: 5, paddingRight: 5 }}>Already Exists</div>
                    )
                }
            }
        ]
        return (
            <>
            {this.props.loading &&
                    <Loader />
                }
                <div className="container csv_form">
                    <div className="col-md-18 row">
                    <div className="col-md-6" style={{ marginTop: 75 }}>
                    <h2 style={{ fontWeight: 700 ,marginTop: 50 }}>Upload Project</h2>
                    </div>
                        <div className="col-md-6">
                            <h6>Please Select a CSV File</h6>
                        </div>
                        <div className="col-md-6">
                            <a href={require("../../../assets/uploadProjects.csv")} >
                                Template for CSV
                            </a>
                        </div>
                        <div className="col-md-9" style={{ marginBottom: 20 }}>
                            <input type="file" className="form-control" accept=".csv" onChange={(e) => {
                                if (e.target.files[0]) {
                                    const name = e.target.files[0].name;
                                    const lastDot = name.lastIndexOf('.');
                                    const ext = name.substring(lastDot + 1);
                                    if (ext == "csv") {
                                        this.setState({ file: e.target.files[0] });
                                    } else {
                                        alert("Please upload csv File")
                                    }
                                }
                            }} />
                            <p style={{ color: "red" }}>{this.state.error}</p>
                        </div>

                        <div className="col-md-9" style={{ display: "flex", flexDirection: "row-reverse" }}>
                            {(this.state.loaderButton ?
                                <button className="btn-submit" style={{ width: 150 }}>

                                    <i className="fa fa-circle-o-notch fa-spin fa-1x fa-fw" style={{ color: "gray" }}></i>
                                </button>
                                :
                                <button className="btn-submit" onClick={() => {
                                    if (this.state.file) {
                                        this.setState({ loaderButton: true, error: "" });
                                        this.uploadFile(this.state.file);
                                    } else {
                                        this.setState({ error: "Please upload file" })
                                    }
                                }} style={{ width: 150, height: 40, cursor: "pointer" }}>
                                    Upload</button>
                            )}
                        </div>
                    </div>
                    <div className="col-md-12 row">
                        {this.props.upload && (this.state.upload.length != 0 || this.props.upload.uploaded) &&
                            <>
                                <div class="col-md-12" style={{ paddingTop: 20 }}>
                                    <button className="btn-danger" onClick={() => {
                                        if (this.props.upload.uploaded) {
                                            this.download(this.props.upload.uploaded.concat(this.state.upload))
                                        } else {
                                            this.download(this.state.upload)
                                        }


                                    }} style={{ width: 150, borderColor: "#555555", backgroundColor: "#555555", cursor: "pointer" }}>
                                        Download csv</button>
                                </div>
                                <Table
                                    data={(this.props.upload.uploaded ? this.props.upload.uploaded.concat(this.state.upload) : this.state.upload)}
                                    columns={columns}
                                />
                                {/* <ReactTable style={{ width: "100%" }}
                                    data={(this.props.upload.uploaded ? this.props.upload.uploaded.concat(this.state.upload) : this.state.upload)}
                                    columns={columns}
                                    ref={this.reactTable}
                                    defaultPageSize={10}
                                    pageSize={10}
                                    onPageChange={this.onTableViewChange}
                                    onSortedChange={this.onTableViewChange}
                                    onExpandedChange={this.onTableViewChange}
                                    onFilteredChange={this.onTableViewChange}
                                    onResizedChange={this.onTableViewChange}
                                /> */}
                            </>
                        }

                    </div>

                </div>
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        upload: state.projectReducer,
        getprojectsLoading: state.projectReducer.getprojectsLoading
    }
}


export default connect(mapStateToProps, projectActions)(UploadProjects);